import React from 'react';
import PropTypes from 'prop-types';

// Migrated from progress-circle.js, which was based off of // spinner code from https://codepen.io/phantomesse/pen/uzeyC?q=loading+circle&limit=all&type=type-pen
const PROGRESS_SPOKE_COUNT = 8.0;
const SPOKE_WIDTH = 4;
const PROGRESS_SPOKE_DURATION = 500;
const PROGRESS_SPOKE_X_OFFSET = 0.75;
const PROGRESS_SPOKE_Y_OFFSET = 1.5;
const PROGRESS_SPOKE_CONTAINER_WIDTH = 25;

const ProgressSpinner = (props) => {
  if (!props.started) {
    return (<div className="loading-spinner" />);
  }

  const delay = (props.animationTime - PROGRESS_SPOKE_DURATION) / PROGRESS_SPOKE_COUNT / 1000.0;
  const progressSpinner = [];

  for (let i = 0; i < PROGRESS_SPOKE_COUNT; i += 1) {
    const degreeTot = ((((PROGRESS_SPOKE_COUNT * 3) / 4) + i) * 360);
    const degree = degreeTot / PROGRESS_SPOKE_COUNT;
    const degreeRadians = degree * (Math.PI / 180);
    const radius = (PROGRESS_SPOKE_CONTAINER_WIDTH - (SPOKE_WIDTH * 3)) / 2;
    const x = (Math.cos(degreeRadians) * radius) + radius + (SPOKE_WIDTH * PROGRESS_SPOKE_X_OFFSET);
    const y = ((Math.sin(degreeRadians) * radius) + radius + (SPOKE_WIDTH * PROGRESS_SPOKE_Y_OFFSET));

    const style = {
      width: `${SPOKE_WIDTH * 1.5}px`,
      height: `${SPOKE_WIDTH / 2}px`,
      top: `${y}px`,
      left: `${x}px`,
      transform: `rotate(${degree}deg)`,
      animationDuration: `${PROGRESS_SPOKE_DURATION / 1000.0}s`,
      animationDelay: `${delay * i}s`,
    };

    const spoke = (
      <div
        key={i}
        className="spoke"
        style={style}
      />
    );

    progressSpinner.push(spoke);
  }
  return (
    <div className="loading-spinner">
      {progressSpinner}
    </div>
  );
};

ProgressSpinner.propTypes = {
  animationTime: PropTypes.number.isRequired,
  started: PropTypes.bool,
};

ProgressSpinner.defaultProps = {
  completed: false,
  started: false,
};

export default ProgressSpinner;



// WEBPACK FOOTER //
// ./src-react/ExportProgressBar/ProgressSpinner.jsx